<script lang="ts">
    import Markdown from "./Markdown.svelte"

    let { table }: { table: TableBlock } = $props()

    const rawRows = table.content.rows ?? []
    const hasHeaders = !table.content.first_is_not_header && rawRows.length > 0
    const headers = hasHeaders ? rawRows[0] : null
    const headerLabels = headers ? headers.columns.map((column) => column.text) : null
    const rows = hasHeaders ? rawRows.slice(1) : rawRows
</script>

<div class="table-wrapper">
    <table>
        {#if hasHeaders && headers}
            <thead>
                <tr>
                    {#each headers.columns as header}
                        <th><Markdown text={header.text} /></th>
                    {/each}
                </tr>
            </thead>
        {/if}
        <tbody>
            {#each rows as row}
                <tr>
                    {#each row.columns as cell, index}
                        <td data-label={headerLabels?.[index]}>
                            <Markdown text={cell.text} />
                        </td>
                    {/each}
                </tr>
            {/each}
        </tbody>
    </table>
</div>

<style lang="less" global>
    @import "../../../css/variables.less";
    .table-wrapper {
        width: 100%;
        overflow-x: auto; // Erlaubt horizontales Scrollen
        -webkit-overflow-scrolling: touch; // Sanftes Scrollen auf iOS

        table {
            width: 100%;
            border-collapse: collapse;
            margin: @space-lg 0;
            background-color: var(--bg-100);
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            border-radius: 4px;
            overflow: hidden;

            thead {
                background-color: var(--dark-100);
                color: var(--bright-100);

                th {
                    padding: @space-md;
                    text-align: left;
                    font-weight: bold;
                    letter-spacing: 0.05em;
                    text-transform: uppercase;
                }
            }
            p {
                margin-bottom: 0rem !important;
            }
            tbody {
                tr {
                    &:nth-child(even) {
                        background-color: var(--bg-200);
                    }

                    &:hover {
                        background-color: var(--bg-200);
                    }

                    td {
                        padding: @space-md;
                        border-bottom: 1px solid var(--bg-300);
                        vertical-align: top;
                    }
                }
            }
        }
    }

    @media @max-mobile {
        .table-wrapper {
            overflow-x: visible;

            table {
                display: block;
                background-color: transparent;
                box-shadow: none;
                border-radius: 0;
                overflow: visible;
            }

            thead {
                border: 0;
                clip: rect(0, 0, 0, 0);
                height: 1px;
                width: 1px;
                margin: -1px;
                overflow: hidden;
                padding: 0;
                position: absolute;
            }

            tbody {
                display: block;

                tr {
                    display: flex;
                    flex-direction: column;
                    margin-bottom: @space-md;
                    background-color: var(--bg-100);
                    border: 1px solid var(--bg-300);
                    border-radius: 6px;
                    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
                    overflow: hidden;

                    &:nth-child(even),
                    &:hover {
                        background-color: var(--bg-100);
                    }

                    td {
                        display: block;
                        border: none;
                        border-bottom: 1px solid var(--bg-300);
                        padding: @space-sm @space-md;
                        position: relative;

                        &:last-child {
                            border-bottom: none;
                        }

                        &::before {
                            content: attr(data-label);
                            display: block;
                            font-size: 0.75rem;
                            font-weight: 600;
                            letter-spacing: 0.05em;
                            text-transform: uppercase;
                            color: inherit;
                            margin-bottom: @space-xs;
                        }
                    }
                }
            }
        }
    }
</style>
